import { useState } from "react";
import deathApi from "../../../../../../apis/death.api";

export default function useUpdateBudgetHook() {
  const [updateLoading, setUpdateLoading] = useState(false);

  const updateBudget = async (records) => {
    console.log("checking for update",records)
    try {
      setUpdateLoading(true);
      await Promise.all(records.map((record) => deathApi.updateBudget(record.id, record)));
    } catch (error) {
      console.error("Failed to update budget records:", error);
    } finally {
      setUpdateLoading(false);
    }
  };

  return { updateBudget, updateLoading };
}
